module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgBrVMLEYMwDG1RgIPhYMwBUwASkICD4QQcbFMADmAKwAGbgi65PY4cg9J93t27XJPwmguvWllgjIkoxMQQqTvxqrUulQtIICBWZkIHynOyJRISBzAn+qLmE1MherJNMt4ebEzcQCxaaihQXBWZTcdTV0tFLhTKEdSbvU3FBySTD4R8fJN5Ih8gNsoRZAO2Q0/ce+pPkEI94kE5AtYIiDcp1KqXc2PljnGf9fyGHMsLtxSw6I79ZCtuGZL7zqueE84e31Mqnwh6ItGT2kQ6NJdmQgMO4hzJ7/UoQoGtzrcfyR8t8rwrXugO/Q/iheq1bZLBZcmrwJ/6TQRC/nyh3+AJxLthhjnGevoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/magnifier-icon.png
// module id = 64
// module chunks = 0